import { useTheme } from '@mui/material/styles';

export type Colors = 'red' | 'yellow' | 'green';
export type Field = 'icon' | 'text';

export const useGetActivityColor = () => {
  const theme = useTheme();

  const colorsMap: Record<Colors, Record<Field, string>> = {
    green: {
      icon: theme.palette.success.light,
      text: theme.palette.success.main,
    },
    yellow: {
      icon: theme.palette.warning.light,
      text: theme.palette.warning.main,
    },
    red: {
      icon: theme.palette.error.light,
      text: theme.palette.error.main,
    },
  };

  const getColor = (field: Field, color?: Colors) =>
    color ? colorsMap[color][field] : theme.palette.text.disabled;

  return { getColor };
};
